"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullscreenButton = void 0;
const preact_1 = require("preact");
const typestyle_1 = require("typestyle");
const Fullscreen_1 = require("../../../Fullscreen");
const style_1 = require("./style");
const Controls_style_1 = require("../../Controls.style");
class FullscreenButton extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isInFullscreen: false
        };
        this.onClick = () => {
            if (Fullscreen_1.Fullscreen.isInFullscreen()) {
                Fullscreen_1.Fullscreen.exit();
            }
            else {
                Fullscreen_1.Fullscreen.enter(this.props.root);
            }
        };
        this.onFullscreen = () => {
            this.setState({
                isInFullscreen: Fullscreen_1.Fullscreen.isInFullscreen()
            });
        };
    }
    componentDidMount() {
        Fullscreen_1.Fullscreen.onChange(this.onFullscreen);
    }
    componentWillUnmount() {
        Fullscreen_1.Fullscreen.onChangeRemove(this.onFullscreen);
    }
    render() {
        return ((0, preact_1.h)("div", { class: (0, typestyle_1.classes)(Controls_style_1.ControlsStyle.button, style_1.FullscreenButtonStyle.button), onClick: this.onClick }, this.state.isInFullscreen ? ((0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentcolor" },
            (0, preact_1.h)("path", { d: "M0 22 L22 22 L22 0 L14 0 L14 14 L0 14 M42 0 L42 22 L64 22 L64 14 L50 14 L50 0 M14 50 L0 50 L0 42 L22 42 L22 64 L14 64 M42 64 L42 42 L64 42 L64 50 L50 50 L50 64 Z" }))) : ((0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentcolor" },
            (0, preact_1.h)("path", { d: "M0 22 L8 22 L8 8 L22 8 L22 0 L0 0 M42 0 L42 8 L56 8 L56 22 L64 22 L64 0 M0 64 L0 42 L8 42 L8 56 L22 56 L22 64 M64 64 L42 64 L42 56 L56 56 L56 42 L64 42 Z" })))));
    }
}
exports.FullscreenButton = FullscreenButton;
